import type { ComponentProps } from "react";
import { crossAppLinkProps } from "@/lib/crossAppLinks";

/** Native link semantics, with the same cross-app policy as localized links. */
export default function SiteAnchor(props: ComponentProps<"a">) {
  return <a {...props} {...crossAppLinkProps(props.href || "")} />;
}
